
(function(){
  function initFaq(root){(root||document).querySelectorAll('.dt-og-faq__q').forEach(function(btn){if(btn.dataset.dtOgInit)return;btn.dataset.dtOgInit='1';btn.addEventListener('click',function(){btn.closest('.dt-og-faq__item').classList.toggle('open');});});}
  function initQuiz(root){(root||document).querySelectorAll('[data-dt-og-quiz]').forEach(function(q){if(q.dataset.dtOgInit)return;q.dataset.dtOgInit='1';var steps=q.querySelectorAll('[data-step]');var answers={};function show(s){steps.forEach(function(el){el.classList.toggle('dt-og-hidden',el.dataset.step!==s);}); if(s==='result') pick();}function pick(){var results=q.querySelectorAll('[data-result]'),best=results[0],score=-1;results.forEach(function(r){var n=0;if(r.dataset.heat===answers.heat)n+=3;if((r.dataset.dish||'').split(',').indexOf(answers.dish)>-1)n+=2;if((r.dataset.flavor||'').split(',').indexOf(answers.flavor)>-1)n+=2;if(n>score){score=n;best=r;}});results.forEach(function(r){r.classList.toggle('dt-og-hidden',r!==best);});}q.querySelectorAll('[data-go]').forEach(function(b){b.addEventListener('click',function(){show(b.dataset.go);});});q.querySelectorAll('[data-key]').forEach(function(b){b.addEventListener('click',function(){answers[b.dataset.key]=b.dataset.value;show(b.dataset.next);});});show('intro');});}
  function initShipping(root){(root||document).querySelectorAll('[data-dt-og-shipping]').forEach(function(bar){function update(cents){var threshold=parseInt(bar.dataset.threshold||'2000',10),pct=Math.min(100,Math.round(cents/threshold*100)),fill=bar.querySelector('[data-fill]'),remain=bar.querySelector('[data-remain]'); if(fill)fill.style.width=pct+'%';bar.classList.toggle('is-unlocked',cents>=threshold);if(remain){var rem=Math.max(0,threshold-cents)/100;remain.textContent=rem.toFixed(2).replace('.',',')+'€';}bar.querySelectorAll('[data-state]').forEach(function(s){var k=s.dataset.state;s.hidden=!((cents===0&&k==='empty')||(cents>0&&cents<threshold&&k==='progress')||(cents>=threshold&&k==='unlocked'));});}
    fetch((window.theme&&theme.routes&&theme.routes.cart)||'/cart.js').then(function(r){return r.json()}).then(function(cart){update(cart.total_price||0)}).catch(function(){update(0)});
    document.addEventListener('cart:updated',function(e){if(e.detail&&e.detail.cart)update(e.detail.cart.total_price||0);});
  });}
  function heatMarkup(value){
    var heat=Math.max(0,Math.min(10,parseInt(value||'0',10)||0)),pips='';
    for(var i=1;i<=10;i+=1)pips+='<span class="dt-og-pip'+(i<=heat?' on':'')+'"></span>';
    return '<div class="dt-og-heat-indicator" data-heat-value="'+heat+'" aria-label="Nivel de picante: '+heat+' de 10"><div class="dt-og-pips" aria-hidden="true">'+pips+'</div><span class="dt-og-heat-num">'+heat+'/10</span></div>';
  }
  function initProducts(root){
    (root||document).querySelectorAll('[data-dt-og-products]').forEach(function(section){
      if(section.dataset.dtOgProductsInit)return;
      section.dataset.dtOgProductsInit='1';
      section.addEventListener('click',function(event){
        var variant=event.target.closest('[data-dt-og-variant]');
        if(variant){
          var card=variant.closest('[data-dt-og-product-card]');
          card.querySelectorAll('[data-dt-og-variant]').forEach(function(button){
            var active=button===variant;
            button.classList.toggle('is-active',active);
            button.setAttribute('aria-checked',active?'true':'false');
          });
          var add=card.querySelector('[data-dt-og-add]');
          var variantInput=card.querySelector('[data-dt-og-variant-input]');
          var available=variant.dataset.variantAvailable==='true';
          add.dataset.variantId=variant.dataset.variantId;
          variantInput.value=variant.dataset.variantId;
          add.disabled=!available;
          add.textContent=available?'+ Añadir':'Agotado';
          var price=card.querySelector('[data-dt-og-price]');
          price.firstChild.nodeValue=(variant.dataset.variantPrice||'')+' ';
          var compare=card.querySelector('[data-dt-og-compare-price]');
          compare.textContent=variant.dataset.variantComparePrice||'';
          compare.hidden=!variant.dataset.variantComparePrice;
          card.querySelector('[data-dt-og-heat]').innerHTML=heatMarkup(variant.dataset.variantHeat);
          var image=card.querySelector('.dt-og-product-card__image');
          if(image&&variant.dataset.variantImage){
            image.src=variant.dataset.variantImage;
            image.srcset='';
            image.alt=variant.dataset.variantImageAlt||'';
          }
          return;
        }
        var addButton=event.target.closest('[data-dt-og-add]');
        if(!addButton||addButton.disabled)return;
        var productCard=addButton.closest('[data-dt-og-product-card]');
        var message=productCard.querySelector('[data-dt-og-message]');
        var variantId=parseInt(addButton.dataset.variantId,10);
        if(!variantId)return;
        addButton.disabled=true;
        addButton.setAttribute('aria-busy','true');
        addButton.textContent='Añadiendo…';
        message.textContent='';
        var rootUrl=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
        fetch(rootUrl+'cart/add.js',{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:variantId,quantity:1}]})
        }).then(function(response){
          return response.json().then(function(data){
            if(!response.ok)throw new Error(data.description||data.message||'No se ha podido añadir el producto.');
            return data;
          });
        }).then(function(result){
          productCard.querySelector('[data-dt-og-quick-add-form]').dispatchEvent(new CustomEvent('ajaxProduct:added',{bubbles:true,detail:{product:result}}));
          return fetch(rootUrl+'cart.js',{headers:{'Accept':'application/json'}});
        }).then(function(response){return response.json();}).then(function(cart){
          addButton.textContent='Añadido';
          document.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true,detail:{cart:cart,source:'dt-og-product-card'}}));
          document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{cart:cart,source:'dt-og-product-card'}}));
          setTimeout(function(){addButton.textContent='+ Añadir';},1400);
        }).catch(function(error){
          addButton.textContent='Error';
          message.textContent=error.message||'No se ha podido añadir el producto.';
          setTimeout(function(){addButton.textContent='+ Añadir';},1800);
        }).finally(function(){
          addButton.disabled=false;
          addButton.removeAttribute('aria-busy');
        });
      });
    });
  }
  function initSubscriptionPolicy(root){
    var template=document.getElementById('DtOgSubscriptionPolicyTemplate');
    if(!template)return;
    var scope=root&&root.querySelectorAll?root:document;
    var policies=[];
    if(scope.matches&&scope.matches('.shopify_subscriptions_app_policy'))policies.push(scope);
    scope.querySelectorAll('.shopify_subscriptions_app_policy').forEach(function(policy){policies.push(policy);});
    policies.forEach(function(policy){
      if(policy.querySelector('.dt-og-subscription-benefits'))return;
      policy.replaceChildren(template.content.cloneNode(true));
    });
  }
  function observeSubscriptionPolicy(){
    if(!document.getElementById('DtOgSubscriptionPolicyTemplate')||document.documentElement.dataset.dtOgSubscriptionObserver)return;
    document.documentElement.dataset.dtOgSubscriptionObserver='1';
    new MutationObserver(function(mutations){
      mutations.forEach(function(mutation){
        mutation.addedNodes.forEach(function(node){
          if(node.nodeType===1)initSubscriptionPolicy(node);
        });
      });
    }).observe(document.body,{childList:true,subtree:true});
  }
  function initAll(root){initFaq(root);initQuiz(root);initShipping(root);initProducts(root);initSubscriptionPolicy(root);}document.addEventListener('DOMContentLoaded',function(){initAll(document);observeSubscriptionPolicy();});document.addEventListener('shopify:section:load',function(e){initAll(e.target);});
})();
